
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';
import { Fuel } from '../model/newfuels.model';

@Injectable({
  providedIn: 'root'
})
export class NewfuelService {
  @LocalStorage() url: Url;

  private headers = new Headers({ 'Content-Type': 'application/json' });
// Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  constructor(public http:HttpClient) { 
  }

  getFuels(filter="",start='', end=''): Observable<Fuel[]> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // }
    } else filter = '';
		return this.http.get<Fuel[]>(this.url.rest + '/tms/getFuelWithItems'+ filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }

  getManifests(fleet_id: number, fuel_date:string): Observable<any[]> { 

    return this.http.get<any[]>(this.url.rest + '/tms/getManifestsForFuel/' + fleet_id + '/' + fuel_date , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }

  createFuel(fuel:Fuel): Observable<Fuel> {
    console.log("create fuel in service.......");
    return this.http.post<Fuel>(this.url.rest + '/tms/saveFuelAdmin2', fuel , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  updateFuel(fuel: Fuel): Observable<Fuel> {
    return this.http.post<Fuel>(this.url.rest + '/tms/editFuelAdmin2', fuel , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  deleteFuel(data): Observable<any> {
    return this.http.post(this.url.rest + '/tms/deleteFuelTMS', data)        
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  deleteItem(id: number): Observable<any> {
    const data = {fuel_item_id: id}
    return this.http.post(this.url.rest + '/tms/deleteFuelItemTMS', data)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  } 


  viewFuelCard(): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getFuelCardsTMS')
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  getFuelCardsForFuels(fleet_id: number, provider_id:number): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getFuelCardsForFuel/' + fleet_id + '/' + provider_id, this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  getAllFuelCards(): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getFuelCardsTMS', this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  getItemsByFuelId(fuel_id): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getFuelItemsByFuelId/' + fuel_id, this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  getFuelItems(filter='', start='', end=''): Observable<any> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // }
    } else filter = '';
    return this.http.get<any>( this.url.rest + '/tms/getFuelItems' + filter, this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  getFuelMiscData(): Observable<any> { 
    return this.http.get<any>( this.url.rest + '/tms/getFuelMiscData', this.httpOptions )
        .pipe(
            retry(1),
            catchError(this.handleError)
        )   
  }

  getFuelSummaryByFleetId(fleet_id): Observable<any[]> { 
    return this.http.get<any[]>(this.url.rest  + '/tms/fleetdetails/getNewFuelSummaryByFleetId/' + fleet_id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }

  getNewFuelSummary(): Observable<any[]> { 
    return this.http.get<any[]>(this.url.rest  + '/tms/fleetdetails/getNewFuelSummary', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
    }

  getFuelWithItemsByFleetId(fleet_id, filter = '', start='', end=''): Observable<any[]> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // } 
    } else filter = '';
  return this.http.get<any[]>(this.url.rest  + '/tms/fleetdetails/getFuelWithItemsByFleetId/' + fleet_id  + filter, this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  getFuelItemsByFuelId(fleet_id): Observable<any[]> { 
    return this.http.get<any[]>(this.url.rest  + '/tms/fleetdetails/getFuelItemsByFuelId/' + fleet_id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getFuelItemsByFleetId(fleet_id, filter='', start='', end=''): Observable<any[]> { 
    if (filter) {
      filter = '/' + filter; 
      if (filter == '/range' && start != '' && end != '')
      // if (start == end){
      //   filter = '/range'
      // }
      // else{
        filter = '/range/' + start + '/' + end; 
      // }
    } else filter = '';
    return this.http.get<any[]>(this.url.rest  + '/tms/getFuelItemsByFleetId/' + fleet_id + filter, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

}